import React from 'react'
import Button from 'components/Button'
import { Box } from 'components/Layout'
import { Label, AdditionalContentWrapper, Text } from 'components/FormFields'
import { COLOR } from 'theme'

interface Props {
  errorMessage: string | undefined
  onChange: (day: string) => void
  daysArray: Array<string>
  disabled: boolean
}

export const SelectDaysOfWeek = ({
  errorMessage,
  onChange,
  daysArray,
  disabled = false,
}: Props) => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  const handleSelectChange = React.useCallback(
    (data: React.MouseEvent<HTMLElement, MouseEvent>) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { id } = data.target as any
      onChange(id)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )
  return (
    <Box border={errorMessage && `1px solid ${COLOR.danger}`} borderRadius="4px">
      <AdditionalContentWrapper type="top">
        <Label size="medium">Select</Label>
      </AdditionalContentWrapper>

      <Box display="flex" justifyContent="space-around" flexWrap="wrap">
        {days.map((day: string) => (
          <Button
            disabled={disabled}
            id={day}
            mb="6px"
            colorVariant={daysArray && daysArray.includes(day) ? 'primary' : 'secondary'}
            onClick={handleSelectChange}
          >
            {day}
          </Button>
        ))}
      </Box>

      <AdditionalContentWrapper type="bottom">
        {errorMessage && <Text type="error">{errorMessage}</Text>}
      </AdditionalContentWrapper>
    </Box>
  )
}
